<template>
  <vs-popup
    class="holamundo chat-adv-settings"
    title="Advanced Settings"
    :active.sync="popupActive2"
  >
    <div class="single-row">
      <label for>Allow Attendees to Create Group</label>
      <vs-switch v-model="settingsData.AllowAttendeestoCreateGroup" />
    </div>
    <br />
    <div class="single-row">
      <label for>Show Language Translation bar in Chat</label>
      <vs-switch v-model="settingsData.ShowLanguageTranslationbarinChat" />
    </div>
    <br />
    <div class="single-row">
      <label for>Enable 1:1 Video Call</label>
      <vs-switch v-model="settingsData.EnableOneToOneVideoCall" />
    </div>
    <br />
    <div class="single-row">
      <div class="single-row">
        <label for>Chat Button</label>
        <vs-radio
          v-model="showChatButton"
          vs-value="Top"
          class="mr-4"
          vs-name="chat-view"
          >Top</vs-radio
        >
        <vs-radio
          v-model="showChatButton"
          vs-value="Bottom"
          class="mr-4"
          vs-name="chat-view"
          >Bottom</vs-radio
        >
        <vs-radio
          v-model="showChatButton"
          vs-value="Both"
          class="mr-4"
          vs-name="chat-view"
          >Both</vs-radio
        >
      </div>
    </div>
    <br />
    <div class="single-row">
      <label for>Default Chat View</label>

      <vs-radio
        v-model="defaultView"
        vs-value="Social Wall"
        class="mr-4"
        vs-name="layout-type-vertical"
        >Social Wall</vs-radio
      >
      <vs-radio
        v-model="defaultView"
        vs-value="Room Listing"
        class="mr-4"
        vs-name="layout-type-horizontal"
        >Room Listing</vs-radio
      >
    </div>
    <br />
    <div class="single-row">
      <label for>Default Chat Button Text</label>

      <vs-input
        class="w-md-1/2"
        v-model="settingsData.DefaultChatButtonText"
        v-validate="'max:12'"
        data-vv-as="Chat Button Text"
        name="ChatText"
        type="text"
      ></vs-input>
    </div>
    <span
      class="text-danger text-sm"
      v-show="errors.has('ChatText')"
      style="float: right"
      ><br />Chat Button Text cannot be more than 12 characters</span
    >
    <br />


    <div class="single-row">
      <label for>Show Toggle for Attendee/Chat</label>
      <vs-switch v-model="settingsData.ShowToggleForAttendeeOrChat" />
    </div>
    <br />
    <div class="single-row" v-if="settingsData.ShowToggleForAttendeeOrChat">
      <div class="single-row">
        <label for>Default Tab Selected</label>
        <vs-radio
          v-model="showDefaultTab"
          vs-value="Attendee"
          class="mr-4"
          vs-name="chat-view"
          >Attendee</vs-radio
        >
        <vs-radio
          v-model="showDefaultTab"
          vs-value="Chat"
          class="mr-4"
          vs-name="chat-view"
          >Chat</vs-radio
        >
      </div>

    </div>
    <br />
    <div class="single-row" v-if="settingsData.ShowToggleForAttendeeOrChat">
      <label for>Always keep Panel Open</label>
      <vs-switch v-model="settingsData.keepChatPanelOpen" />
    </div>
    <br />

    <vs-button
      :disabled="errors.has('ChatText')"
      color="rgb(76, 139, 246)"
      type="filled"
      class="sub-btn"
      v-on:click="saveSettings"
      >Save</vs-button
    >
  </vs-popup>
</template>
<script>
export default {
  components: {},
  props: {
    data: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      settingsData: {
        AllowAttendeestoCreateGroup: true,
        ShowLanguageTranslationbarinChat: true,
        EnableOneToOneVideoCall: false,
        ShowToggleForAttendeeOrChat: false,
        keepChatPanelOpen: false,
      },
      popupActive2: this.data,
      defaultView: "Social Wall",
      showChatButton: "Top",
      showDefaultTab: "Chat",
    };
  },
  watch: {},
  computed: {},
  methods: {
    getDefaultSettings() {
      this.IsDefaultSettings = true;
      this.settingsData = {
        AllowAttendeestoCreateGroup: true,
        ShowLanguageTranslationbarinChat: true,
        EnableOneToOneVideoCall: false,
        ShowToggleForAttendeeOrChat: false,
        keepChatPanelOpen: false
      };
      this.popupActive2 = true;
      this.$vs.loading.close();
    },
    getSettings() {
      this.$vs.loading();
      this.IsDefaultSettings = false;
      this.$store.dispatch("chatgroupManagement/getSettings").then((res) => {
        if (res) {
          this.settingsData = res;
        }
        this.popupActive2 = true;
        this.$vs.loading.close();
      });
    },
    saveSettings() {
      this.$vs.loading();
      this.settingsData.DefaultView = this.defaultView;
      this.settingsData.ShowChatFloatingButton = this.showChatButton;
      this.settingsData.ShowDefaultTab = this.showDefaultTab;
      console.log("settingsData========",this.settingsData);
      
      this.$store
        .dispatch("chatgroupManagement/saveSettings", {
          settingsData: this.settingsData,
          IsDefaultSettings: this.IsDefaultSettings,
        })
        .then((res) => {
          this.$vs.notify({
            color: "success",
            position: "top-center",
            title: "Settings",
            text: res.message,
          });
          this.IsDefaultSettings = false;
          this.popupActive2 = false;
          this.$emit("saveSettingsData");
          this.$vs.loading.close();
        });
    },
  },
  mounted() {},
  created() {
    this.$store.dispatch("chatgroupManagement/getSettings").then((res) => {
      if (res) {
        this.settingsData = res;
        if (res.DefaultView != undefined) {
          this.defaultView = res.DefaultView;
        } else {
          this.defaultView = "Social Wall";
        }

        if (res.ShowChatFloatingButton != undefined) {
          this.showChatButton = res.ShowChatFloatingButton;
        } else {
          this.showChatButton = "Top";
        }
        if (res.ShowDefaultTab != undefined) {
          
          this.showDefaultTab = res.ShowDefaultTab;
        } else {
          this.showDefaultTab = "Chat";
        }
      } else {
        this.getDefaultSettings();
      }
    });
  },
};
</script>
